var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getFormattedEventName, getFormattedCustomEventName, } from './utils/get-formatted-event-names';
/**
 * Name: '@subscriber/selectedSupplier': {[name]: event listener}
 * subscriber:
 * event
 * listener
 */
var Databus = /** @class */ (function () {
    function Databus(params) {
        var _this = this;
        /**
         * addEvent - method for adding a new custom event
         * @param params - an object that stores the field "detail"
         * "detail" is an event-dependent value associated with this event
         */
        this.addEvent = function (params) {
            return _this.addBaseEvent(__assign(__assign({}, params), { eventBaseName: getFormattedEventName(_this.eventName) }));
        };
        this.addCustomEvent = function (params) {
            return _this.addBaseEvent(__assign(__assign({}, params), { eventBaseName: getFormattedCustomEventName(_this.eventName) }));
        };
        this.addBaseEvent = function (_a) {
            var id = _a.eventId, detail = _a.detail, eventBaseName = _a.eventBaseName;
            Databus.checkEventState(eventBaseName);
            var eventId = id || eventBaseName;
            var prevData = Databus.eventState[eventBaseName][eventId];
            Databus.eventState[eventBaseName][eventId] = __assign(__assign({}, prevData), { event: new CustomEvent(eventId, {
                    detail: detail,
                }) });
        };
        /**
         * AddEventListener - method for adding a new listener
         * @param eventId
         * @param listener - a function that will be called after receiving
         * a notification with the name of the type of the signed event
         */
        this.addEventListener = function (params) {
            return _this.addBaseEventListener(__assign(__assign({}, params), { eventBaseName: getFormattedEventName(_this.eventName) }));
        };
        this.addCustomEventListener = function (params) {
            return _this.addBaseEventListener(__assign(__assign({}, params), { eventBaseName: getFormattedCustomEventName(_this.eventName) }));
        };
        this.addBaseEventListener = function (_a) {
            var id = _a.eventId, pureListener = _a.listener, eventBaseName = _a.eventBaseName;
            Databus.checkEventState(eventBaseName);
            var eventId = id || eventBaseName;
            var listener = function (_a) {
                var detail = _a.detail;
                return pureListener(detail);
            };
            var prevEventData = Databus.eventState[eventBaseName][eventId];
            if (prevEventData === null || prevEventData === void 0 ? void 0 : prevEventData.listener) {
                console.warn("Listener " + eventId + " was already added");
                return;
            }
            Databus.eventState[eventBaseName][eventId] = __assign(__assign({}, prevEventData), { listener: listener });
            window.addEventListener(eventId, listener);
        };
        /**
         * removeEventListener - method to remove the listener with
         * the name of the type of the signed event
         */
        this.removeEventListener = function (params) {
            var eventsBundleName = Databus.getEventBundleName(_this.eventName);
            if (!eventsBundleName) {
                return;
            }
            var searchedEventId = (params === null || params === void 0 ? void 0 : params.eventId) || eventsBundleName;
            var eventsBundle = Databus.eventState[eventsBundleName];
            var eventData = eventsBundle[searchedEventId];
            var eventListener = eventData === null || eventData === void 0 ? void 0 : eventData.listener;
            if (!eventListener) {
                console.warn("Listener " + searchedEventId + " was already removed");
                return;
            }
            window.removeEventListener(searchedEventId, eventListener);
            delete Databus.eventState[eventsBundleName][searchedEventId];
            if (Object.keys(eventsBundle).length === 0) {
                delete Databus.eventState[eventsBundleName];
            }
        };
        this.eventName = params.name;
    }
    Databus.checkEventState = function (eventName) {
        if (!Databus.eventState[eventName]) {
            Databus.eventState[eventName] = {};
        }
    };
    /**
     * eventState is needed for storing information about events by key.
     * It has a object structure:
     * event - is a custom event
     * listener - is a listener, what will listen events
     */
    Databus.eventState = {};
    /**
     * dataState is needed for storing data that will share by subscriber
     */
    Databus.dataState = {};
    Databus.getData = function (_a) {
        var name = _a.name;
        return Databus.dataState[name];
    };
    Databus.getEventBundleName = function (eventName) {
        var eventSectionName = getFormattedEventName(eventName);
        if (Databus.eventState[eventSectionName]) {
            return eventSectionName;
        }
        var customEventSectionName = getFormattedCustomEventName(eventName);
        if (Databus.eventState[customEventSectionName]) {
            return customEventSectionName;
        }
        return null;
    };
    Databus.dispatchEvent = function (_a) {
        var eventName = _a.eventName, eventId = _a.eventId;
        var _b;
        var eventsBundleName = Databus.getEventBundleName(eventName);
        if (!eventsBundleName) {
            return;
        }
        var eventsBundle = Databus.eventState[eventsBundleName];
        if (eventId) {
            var searchedEvent = (_b = eventsBundle[eventId]) === null || _b === void 0 ? void 0 : _b.event;
            if (searchedEvent) {
                window.dispatchEvent(searchedEvent);
            }
            return;
        }
        for (var key in eventsBundle) {
            var searchedEvent = eventsBundle[key].event;
            if (searchedEvent) {
                window.dispatchEvent(searchedEvent);
            }
        }
    };
    /**
     * setData - method for setting new data to dataState
     * @param values - keys
     */
    Databus.setData = function (_a) {
        var values = _a.values;
        for (var valueName in values) {
            Databus.dataState[valueName] = values[valueName];
            var eventsBundleName = getFormattedEventName(valueName);
            var eventsBundle = Databus.eventState[eventsBundleName];
            if (!eventsBundle) {
                continue;
            }
            for (var eventId in eventsBundle) {
                var event_1 = eventsBundle[eventId].event;
                if (event_1) {
                    Databus.dispatchEvent({
                        eventName: valueName,
                        eventId: eventId,
                    });
                }
            }
        }
    };
    return Databus;
}());
export { Databus };
